export const TEST_ID = 'highlightTabs';
